import { Component, Input, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { Prompt } from './../../_models/prompt';
import { ImageService } from './../../_services/image.service';

@Component({
  selector: 'app-revise-question-prompt',
  templateUrl: './revise-question-prompt.component.html',
  styleUrls: ['./revise-question-prompt.component.css']
})
export class ReviseQuestionPromptComponent implements OnInit {
  loading_answer_options=false
  @Input() prompt:Prompt= undefined
  constructor(private imageService: ImageService) { }
   answerGivenPartName=""
  ngOnInit(): void {
    this.loading_answer_options=true
    let isAnswerImage =this.prompt.correctAnswer.valueType=="DATATYPE_IMAGE"
    if(isAnswerImage){
      this.initAnswerGivenPartName()
      let oList=[]
      oList.push(this.imageService.questionOptionImage(this.prompt.server_prompt_id,"answer"))
      oList.push(this.imageService.questionOptionImage(this.prompt.server_prompt_id,this.answerGivenPartName))

      forkJoin(oList).subscribe(
        resultArray=>{
          for(let i=0;i < this.prompt.choiceOptions.length;i++){
            let iValue =resultArray[i]
            if(i==0){
              this.prompt.correctAnswer.display="<img src=data:image/png;base64,"+iValue+">"
            }else if(i==1){
              this.prompt.answerGiven.display="<img src=data:image/png;base64,"+iValue+">"
            }
          }
          this.loading_answer_options=false
        }
      )

    }else{
      this.loading_answer_options=false
    }

  }

  initAnswerGivenPartName(){
    for(let i=0; i < this.prompt.choiceOptions.length;i++){
      let myChoice = this.prompt.choiceOptions[i]

      let value=myChoice['value']
      if(JSON.stringify(value)==this.prompt.answerGiven.display){
        this.answerGivenPartName = myChoice['name']
      }
    }
  }
}
